import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    height: '36px',
    padding: '0 16px',
    letterSpacing: 'normal',
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    '&$outlinedSecondary': {
      border: theme.borders.default,
      borderRadius: theme.borders.borderRadius,
    },
  },
  outlinedSecondary: {},
})

function ClassNames(props) {
  const { onClick, variant, ...rest } = props
  return (
    <Button
      variant={variant}
      color="secondary"
      className={props.classes.root}
      style={{ ...props.style }}
      onClick={onClick}
      {...rest}
    >
      {props.children ? props.children : 'class names'}
    </Button>
  )
}

ClassNames.defaultProps = {
  variant: 'outlined',
}

const SecondaryButton = withStyles(styles)(ClassNames)
SecondaryButton.displayName = 'SecondaryButton'
export default SecondaryButton
